import * as types from './constants';

// Billing Subscription Modify
export const billingSubscriptionModifyRequest = data => (
  { type: types.BILLING_SUBSCRIPTION_MODIFY_REQUEST, payload: data }
);

export const billingSubscriptionModifyDone = data => (
  { type: types.BILLING_SUBSCRIPTION_MODIFY_DONE, payload: data }
);

export const billingSubscriptionModifyFailed = errors => (
  { type: types.BILLING_SUBSCRIPTION_MODIFY_FAILED, payload: errors }
);

export const billingSubscriptionModifyReset = () => (
  { type: types.BILLING_SUBSCRIPTION_MODIFY_RESET }
);
